
let urlHead = 'https://laravel.rakumart.us'
export default urlHead